import { If } from "react-extras";
import MediaPlayer from "../../lib/media_player/media_player";
import React from "react";
import {
  promotionCodeValueToDisplay,
  redemptionCodeValueToDisplay,
} from "./campaign_editor_helpers";
import "./campaign_editor.scss";
import {
  CampaignDetailsSummaryPageInfo,
  SummaryPageInfo,
  SummaryPageSectionWrapper,
} from "../../lib/summary-page-sections/summary-page-sections";
import { quillIsEmpty } from "../../../lib/forms";
import { DistributionTypeContinuous, DistributionTypeDiscrete } from "../../../constants/campaigns";
import isEmpty from "lodash/isEmpty";

const positionToFriendlyNames = {
  preRoll: "Pre-Roll",
  midRoll: "Mid-Roll",
  postRoll: "Post-Roll",
};

const distributionToFriendlyName = {
  [DistributionTypeContinuous]: "All Episodes",
  [DistributionTypeDiscrete]: "Select Episodes",
};

export let SummaryPage = props => {
  const { campaign, updatePage } = props;
  if (!campaign) return null;

  const targetingOptions = Object.entries(campaign?.targetingOptions ?? [])
    .filter(([, val]) => val)
    .map(([key]) => positionToFriendlyNames[key])
    .join(", ");

  return (
    <div className={"summary-page"}>
      <SummaryPageSectionWrapper updatePage={updatePage} pageNumber={0} title={"campaign details"}>
        <CampaignDetailsSummaryPageInfo campaign={campaign} />
      </SummaryPageSectionWrapper>
      <SummaryPageSectionWrapper updatePage={updatePage} pageNumber={1} title={"PRODUCT SAMPLES"}>
        <>
          <SummaryPageInfo
            noColon
            title={"Free product samples?*"}
            text={redemptionCodeValueToDisplay[campaign.productExchangeType]}
            newline
          />
          <If condition={campaign.productExchangeType === "instructions"}>
            <>
              <SummaryPageInfo
                title={"Redemption Instructions*"}
                text={campaign.productExchangeInstructions}
                newline
              />
              {campaign.redemptionCodes && (
                <SummaryPageInfo
                  title={"Number of Redemption Codes Uploaded*"}
                  text={Object.keys(campaign.redemptionCodes).length}
                />
              )}
            </>
          </If>
        </>
      </SummaryPageSectionWrapper>
      <SummaryPageSectionWrapper updatePage={updatePage} pageNumber={2} title={"AD FORMAT"}>
        <If condition={campaign.style === "hostRead"}>
          <SummaryPageInfo
            title={"Host-Read Script or Talking Points*"}
            text={<div dangerouslySetInnerHTML={{ __html: campaign.script }} />}
          />
          <If condition={!!campaign.scriptTip && !quillIsEmpty(campaign.scriptTip)}>
            <SummaryPageInfo
              title={"Additional Requirements (Optional)"}
              text={<div dangerouslySetInnerHTML={{ __html: campaign.scriptTip }} />}
            />
          </If>
          <SummaryPageInfo
            title={"Campaign Promotion Code*"}
            text={promotionCodeValueToDisplay[campaign.promoCodeType]}
          />
        </If>
        <If condition={campaign?.style === "campaignAudio"}>
          <SummaryPageInfo
            title={"Pre-Recorded Audio*"}
            text={
              <>
                <div>This is the audio that will be inserted into a podcast.</div>
                {!isEmpty(campaign?.contentMediaFileUUID) && (
                  <MediaPlayer mediaFileUUID={campaign?.contentMediaFileUUID} />
                )}
              </>
            }
          />
        </If>
      </SummaryPageSectionWrapper>
      <SummaryPageSectionWrapper
        updatePage={updatePage}
        pageNumber={3}
        title={"DISTRIBUTION REACH"}>
        <SummaryPageInfo
          title={"Ad Distribution*"}
          text={distributionToFriendlyName[campaign.distributionType]}
        />
        <SummaryPageInfo
          title={"Ad Placement*"}
          text={campaign.targetingOptions && targetingOptions}
        />
        <If condition={campaign.distributionType === DistributionTypeContinuous}>
          {`This advertisement will play in the ${targetingOptions} across All Episodes on a show’s catalog.`}
        </If>
        <If condition={campaign.distributionType === DistributionTypeDiscrete}>
          {`This advertisement will play in the ${targetingOptions} position on Select Episodes that you purchase. The ad will remain on a show’s episode for 90 days.`}
        </If>
      </SummaryPageSectionWrapper>
    </div>
  );
};
